export default {
    create_template_edit: "Editar plantilla",
    create_template_create: "Crear plantilla",
    create_template_create_message: "Se ha creado la plantilla",
    create_template_edit_message: "La plantilla ha sido editada",
    create_template_name: "Nombre",
    create_template_language: "Lenguaje",
    create_template_module_code: "Código del módulo",
    create_template_save: "Guardar",
    create_template_no_changes_to_save: "No hay cambios que guardar",
    create_template_save_new_template: "Guardar como nueva plantilla",
    create_template_same_name: "Ya existe una plantilla con el mismo nombre",

    create_template_confirm_to_continue: "Confirmar para continuar",
    create_template_confirm_message_save: "Tienes cambios pendientes de guardar, ¿quieres continuar sin guardar?",
    create_template_continue: "Continuar",
    create_template_confirm_to_save: "Confirmar para guardar",
    create_template_save_cloud_login_page_for: "¿Está seguro de que desea guardar la página actual de inicio de sesión en la nube para",
    create_template_confirm: "Confirmar",
}